import {GamesItem} from "../../items/games/GamesItem";
import {kGames} from "../../../constants/games";

export default function GamesList() {
    // Used in GamesScreenContent to display list of
    // local Games

    // BUILD
    return (
        <div className="mt-[24px] w-full h-full grid gap-[16px] [grid-template-columns:repeat(auto-fill,360px)] justify-start">
            {kGames.map((game, index) => (
                <GamesItem key={index} game={game} />
            ))}
        </div>
    )
}